/**
 * @file useIndividualViewRouteGuard.js
 * @description Keeps Individual-only routes in Individual view. A Client Admin who opens
 * /my-assets, /my-benefits, /my-messages or /my-home is switched over before the page
 * renders, matching a manual "Switch to Individual View".
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../store/Contexts';
import { isIndividualViewRoute } from '../utils/individualViewRoutes';
import { useIndividualViewNavigation } from './useIndividualViewNavigation';

function useIndividualViewRouteGuard() {
    const { pathname } = useLocation();
    const { isLoggedIn } = useAuthContext();
    const { forceIndividualView } = useIndividualViewNavigation();

    useEffect(() => {
        if (!isLoggedIn || !isIndividualViewRoute(pathname)) {
            return;
        }

        forceIndividualView();
    }, [isLoggedIn, pathname]);
}

export { useIndividualViewRouteGuard };
